<script>
import Modal from "@/components/_Shared/Modal";
import InputGroup from "@/components/_Shared/InputGroup";
import GoogleMaps from "@/components/_Shared/GoogleMaps";
import { mapActions } from "vuex";

export default {
  props: {
    address: {
      type: Object,
      required: true
    }
  },
  components: {
    Modal,
    InputGroup,
    GoogleMaps
  },
  data() {
    return {
      preloader: false,
      city: null,
      district: null,
      query: "",
      error: "",
      lat: null,
      lng: null
    };
  },

  methods: {
    ...mapActions("cities", ["searchByName"]),
    ...mapActions("addresses", ["update"]),

    async submit() {
      this.preloader = true;

      try {
        let valid = await this.$validator.validateAll();

        if (valid) {
          let data = {
            id: this.address.id,
            address: {
              street: this.address.street,
              street_number: this.address.street_number,
              zip_code: this.address.zip_code,
              complement: this.address.complement,
              reference: this.address.reference,
              name: this.address.name,
              lonlat: this.address.lonlat
            },
            district_id: this.district_id
          };

          let res = await this.update(data);

          this.$emit("close");
          this.$emit("refresh");
        }
      } catch (e) {}

      this.preloader = false;
    },

    async checkPlace(place) {
      try {
        let city = await this.searchByName(place.city);
        city = city[0];
        if (!city)
          throw {
            title: "Ops, ocorreu um erro!",
            description: "A donamaid ainda não chegou na sua cidade ;("
          };

        let district = city.districts.find(
          el => el.display_name.toLowerCase() === place.district.toLowerCase()
        );
        if (!district)
          throw {
            title: "Ops, ocorreu um erro!",
            description: "A donamaid ainda não chegou no seu bairro ;("
          };

        this.city = city;
        this.district = district;
        this.address.street = place.street;
        this.address.street_number = place.street_number;
        this.address.zip_code = place.zip_code;
        this.address.lonlat = place.lonlat;
        this.error = "";
      } catch (e) {
        this.resetAddress();
        this.error = e;
      }
    },

    resetAddress() {
      this.city = null;
      this.district = null;
      this.address.street = "";
      this.address.street_number = "";
      this.address.zip_code = null;
      this.address.lonlat = "";
    },

    showAddress() {
      return this.city && this.district && this.address.street;
    },

    getLatLng() {
      let arr = this.address.lonlat.split(" ");
      this.lng = Number(arr[1].substr(1));
      this.lat = Number(arr[2].substr(0, arr[2].length - 1));
    }
  },

  mounted() {
    this.getLatLng();
  }
};
</script>

<template>
  <modal
    title="NOVO ENDEREÇO"
    subtitle="Informe os dados do novo endereço"
    size="md"
    @close="$emit('close')"
  >
    <template slot="body">
      <google-maps
        name="address"
        @placeChanged="checkPlace"
        @clearData="resetAddress"
        :lat="lat"
        :lng="lng"
      />

      <div class="badge error mt-10" v-if="error">
        <b class="mb-5">{{ error.title }}</b>
        <small>{{ error.description }}</small>
      </div>

      <div v-if="showAddress()">
        <div class="form-group">
          <InputGroup
            :error="errors.first('nome')"
            name="nome"
            v-validate="'required'"
            v-model="address.name"
            label="nome ex: (casa, escritório...)"
          />
        </div>

        <div class="form-group">
          <InputGroup v-model="address.street" label="rua" disabled />
          <InputGroup
            :error="errors.first('número')"
            v-validate="'required|numeric|min:1'"
            v-model="address.street_number"
            label="número"
          />
          <InputGroup
            :error="errors.first('cep')"
            :mask="'#####-###'"
            v-validate.disabled="'required|numeric|min:8'"
            v-model="address.zip_code"
            label="cep"
          />
        </div>

        <div class="form-group">
          <InputGroup v-model="district.display_name" label="bairro" disabled />
          <InputGroup v-model="city.display_name" label="cidade" disabled />
          <InputGroup v-model="city.state.code" label="uf" disabled />
        </div>

        <div class="form-group">
          <InputGroup
            :error="errors.first('complemento')"
            v-model="address.complement"
            label="complemento"
          />
          <InputGroup
            :error="errors.first('referência')"
            v-model="address.reference"
            label="referência ex: rua sem saída"
          />
        </div>
      </div>
    </template>

    <template slot="footer">
      <button class="btn bg-purple-outline" @click="$emit('close')">
        fechar
      </button>
      <button
        class="btn bg-purple"
        :class="{ 'btn--loading': preloader }"
        @click="submit"
      >
        <span>atualizar</span>
      </button>
    </template>
  </modal>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/_Shared/Addresses/EditAddress.vue